module.exports = __webpack_public_path__ + "img/img_index_banner_xkt_l@2x.b44bfcee.png";